

















































































































































import {Vue, Prop, Component, Watch} from 'vue-property-decorator';
import restService from '@/services/restService';
import vuetifyToast from "vuetify-toast";
import Passenger from '../Passenger/models/Passenger';
import TransportationPermission from '../Passenger/models/TransportationPermission';
import TransportationPermissionEditor from '../Passenger/components/TransportationPermissionEditor.vue'
import { IPermissionWithPassengerName } from './OrganizationTransportationPermissions.vue';
import { AxiosResponse } from 'axios';
import DateTimePicker from '../DatetimePicker.vue';
@Component({
  components: {
    TransportationPermissionEditor,
    DateTimePicker,
  }
})
export default class PassengerTransportationPermissionTable extends Vue {

search: string = '';
loading = false;
showTransportationPermissionEditor = false;
selectedPermission: TransportationPermission | null = null;
selectedPassenger: Passenger | null = null;
dateFilter: boolean = false;
start: string = '';
end: string = '';
pagination = {
    rowsPerPage: 25 // -1 for All,
}
@Prop() private startDate: string;
@Prop() private endDate: string;
@Prop() private filterWithDates: boolean;
@Prop({default: () => []}) private permissions: IPermissionWithPassengerName[];

@Watch('filterWithDates', {immediate: true})
filterWithDatesChanged(immediate: true) {
  this.dateFilter = this.filterWithDates;
}

@Watch('startDate', {immediate: true})
startDateChanged() {
  this.start = this.startDate;
}

@Watch('endDate', {immediate: true})
endDatesChanged() {
  this.end = this.endDate;
}

get headers() {
    
    const headers = [
      { text: this.$t('generic.header.passenger.one', 'Passenger'),
        value: 'name', align: 'left', sortable: true },
      { text: this.$t('generic.instance', 'Instance'),
        value: 'mainPlace.movitInstanceName', align: 'left', sortable: true },
      { text: this.$t('passenger.prop.destinations.main', 'Main place'),
        value: 'mainPlace.alias', align: 'left', sortable: true },
      { text: this.$t('passenger.prop.transportationPermissions.single', 'Transportation permission'),
        value: 'transportationPermission.name', align: 'left', sortable: true },
      { text: this.$t('passenger.prop.transportationPermissions.startDate', 'Start date'),
        value: 'transportationPermission.startDate', align: 'left', sortable: true },
      { text: this.$t('passenger.prop.transportationPermissions.endDate', 'End date'),
        value: 'transportationPermission.endDate', align: 'left', sortable: true },
      { text: this.$t('passenger.prop.transportationPermissions.price', 'Price'),
        value: 'transportationPermission.priceCode', align: 'left', sortable: true },
      { text: this.$t('transportationPermission.costCenter', 'Cost center'),
        value: 'transportationPermission.costCenter.name', align: 'left', sortable: true },
      { text: this.$t('booking.info.state.label', 'State'),
        value: 'transportationpermission.isDraft', align: 'left', sortable: false },
    ];

    return headers;
  }

  dateFilterSet() {
    this.$emit('filterWithDatesChanged', this.dateFilter);
  }

  async openPassengerPermission(permission: IPermissionWithPassengerName) {
    this.selectedPassenger = (await restService.passengers.getPassengersByIds([permission.transportationPermission.passengerId]))[0];
    console.log("this.selectedPassenger", this.selectedPassenger);
    if (!this.selectedPassenger){
      vuetifyToast.error(
        this.$i18n.translate(
          "passenger.passenger_not_found",
          "API connection error."
        )
      );
      return;
    }
    await this.$store.dispatch(
        "passenger/getPassengerTransportationPermissionInfo", 
        { 
          params: { 
            passengerId: this.selectedPassenger.id 
          }
      }
    );
    this.selectedPermission = permission.transportationPermission;
    this.showTransportationPermissionEditor = true;
  }

  clearSelected() {
    this.selectedPassenger = null;
    this.selectedPermission = null;
    this.showTransportationPermissionEditor = false;
  }

  updatePermission(permission: TransportationPermission) {
    this.$emit('updatePermissions', permission);
    this.clearSelected();
  }

  removePermission(permission: TransportationPermission) {
    this.$emit('removePermission', permission);
    this.clearSelected();
  }
  
}
